import React, {Component} from 'react';
import AccountRemittanceContainer from '../../../containers/account_remittance_container';
import Loader from '../../universal/loader';
import {Button, Grid, Header, Icon, Message, Popup, Segment} from "semantic-ui-react";
import * as hinchLogo from "../../../assets/hinchWhitebackgroundLogo.png";
import RemittanceAdjustment from "./remittance_adjustment";

class ViewRemittanceEstimate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            message: undefined,
            estimateId: undefined,
            showAdjustmentsPane: false,
            showConfirmOpen: false
        }
    }

    componentWillMount() {
        this.setState({estimateId: this.props.match.params.estimateId});
        this.props.getEstimateDetails(this.props.match.params.estimateId)
    }

    adjustmentUpdateInfo = (response) => {
        if (response.success) {
            this.setState({
                message: 'Successfully Updated Adjustments',
                showAdjustmentsPane: false,
                showConfirmOpen: false
            });
            setTimeout(() => {
                this.setState({message: undefined})
            }, 5000)
        }
    };

    handleView = (show) => {
        this.setState({showAdjustmentsPane: show});
    };

    render() {
        const estimateDetail = this.props.estimateDetail;
        return (<div style={{width: '80%', margin: 'auto'}}>
            {this.props.isFetching && <Loader/>}
            {!this.props.isFetching && estimateDetail && <div style={{width: '95%', margin: 'auto'}}>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Header size="large" content={"Remittance Pipeline"} textAlign="left"/>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Header size="large" content={estimateDetail['date']} textAlign="right"/>
                        </Grid.Column>
                    </Grid.Row>

                    {this.state.message && <Grid.Row>
                        <Grid.Column width={8}>

                        </Grid.Column>
                        <Grid.Column width={8}>
                            <div>
                                <Message positive content={<span className="format-bold">{this.state.message}</span>}
                                         onDismiss={() => {
                                             this.setState({message: undefined})
                                         }}/>
                            </div>
                        </Grid.Column>
                    </Grid.Row>}


                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Segment style={{backgroundColor: '#249AC4', color: 'white', height: '100%'}}>
                                <div>
                                    <Grid stackable style={{marginTop: '0'}}>
                                        <Grid.Row style={{padding: '0 0 1% 0'}}>
                                            <Grid.Column width={7}>
                                                <img src={hinchLogo} alt="Hinch Property Logo"/>
                                            </Grid.Column>
                                            <Grid.Column width={9}>
                                                <div>
                                                    <div>
                                                        <p className="format-bold">Address</p>
                                                        <span>
                                                                Suite 3, First Floor Offices
                                                            </span>
                                                        <span>
                                                                East House,Chiltern Avenue,Amersham
                                                            </span>
                                                        <p>
                                                            Bucks, HP6 5AE
                                                        </p>
                                                    </div>
                                                </div>
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row style={{textAlign: 'center'}}>
                                            <div style={{width: '50%'}}>
                                                VAT Reg No: ASD453
                                            </div>
                                            <div style={{width: '50%'}}>
                                                Terms: On Receipt
                                            </div>
                                        </Grid.Row>
                                    </Grid>
                                </div>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Segment style={{backgroundColor: '#F9FAFB', height: '100%'}}>
                                <div>
                                    <p className="format-bold"> Remittance To</p>
                                    <dl>
                                        <dt>Name</dt>
                                        <dd>: {estimateDetail['clerk_profile_name']}</dd>
                                        <dt>Address</dt>
                                        <dd>: {estimateDetail['clerk_profile_address']}</dd>
                                        <dt>Email</dt>
                                        <dd>: {estimateDetail['clerk_profile_email']}</dd>
                                    </dl>
                                </div>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <table width="100%" border="1" cellPadding="0" cellSpacing="0"
                                   style={{borderCollapse: 'collapse', borderColor: '#f5f5f5'}}>
                                <tbody>
                                <tr style={{backgroundColor: '#249AC4', color: 'white', height: '30px'}}>
                                    <th>Date</th>
                                    <th>Agent Ref.Id</th>
                                    {/*<th>Agent Name</th>*/}
                                    <th>Property Address</th>
                                    <th>Job Type</th>
                                    <th>Furnishing</th>
                                    <th>Size</th>
                                    <th>Amount</th>
                                </tr>

                                <tr>
                                    <td className="center-aligned">{estimateDetail.inspection['inspection_time']['inspection_date']}</td>
                                    <td className="center-aligned">{estimateDetail.inspection['reference_id']}</td>
                                    {/*<td className="center-aligned">{estimateDetail.inspection['agent_profile_name']}</td>*/}
                                    <td width="20%"
                                        style={{padding: '1%'}}>{estimateDetail.inspection['property_address']}</td>
                                    <td className="formatcase">{estimateDetail.inspection['inspection_type']}</td>
                                    <td className="format-capitalize center-aligned">{estimateDetail.inspection['furnishing_type']}</td>
                                    <td className="center-aligned">{estimateDetail.inspection['property_size']}</td>
                                    <td className="center-aligned">£ {estimateDetail['inspection_amount']}</td>
                                </tr>
                                {estimateDetail['remittance_adjustments'].length > 0 &&
                                <tr>
                                    <td colSpan={5} className="pad-all format-bold"><Popup
                                        trigger={<Icon name="trash"
                                                       size='large'
                                                       color='grey'
                                        />}
                                        content={<Button negative content="Sure to Remove Adjustment?"
                                                         onClick={(e) => {
                                                             this.props.deleteAdjustment(estimateDetail['remittance_adjustments'][0]['id'], this.adjustmentUpdateInfo, this.state.estimateId);
                                                         }}/>}
                                        on="click"
                                        position="right center"
                                        hideOnScroll
                                    /> Adjustments : {estimateDetail['remittance_adjustments'][0]['description']}</td>
                                    <td className="center-aligned format-bold" style={{borderRight: '0'}}> Amount:</td>
                                    <td className="center-aligned"
                                        style={{borderLeft: '0'}}>£ {estimateDetail['remittance_adjustments'][0]['amount']}</td>
                                </tr>
                                }
                                <tr>
                                    <td colSpan={5} className="right-aligned format-bold pad-all">Total Remittance Amount</td>
                                    <td colSpan={2}
                                        className="format-bold center-aligned">£ {estimateDetail['total_amount']}</td>
                                </tr>
                                </tbody>

                            </table>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                <Grid>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Segment style={{backgroundColor: '#F9FAFB', height: '220px'}}>
                                <div>
                                    <p className="format-bold"> Bank Details</p>
                                    <dl style={{padding: '0 5%'}}>
                                        <dt>Bank Name</dt>
                                        <dd>: Barclays</dd>
                                        <dt>A/C. Name</dt>
                                        <dd>: Hinch PM</dd>
                                        <dt>Sort Code</dt>
                                        <dd>: 20-02-06</dd>
                                        <dt>A/C Number</dt>
                                        <dd>: 83943496</dd>
                                        <dt>Email</dt>
                                        <dd>: accounts@hinchpm.com</dd>
                                    </dl>
                                </div>
                            </Segment>
                        </Grid.Column>
                        {this.props.userRole === 'admin' && <Grid.Column width={8}>
                            <div className="pull-right">
                                <Button content="Add/Edit Adjustment" primary onClick={() => {
                                    this.handleView(true)
                                }}/>
                            </div>
                        </Grid.Column>}
                    </Grid.Row>
                </Grid>
                {this.state.showAdjustmentsPane &&
                <RemittanceAdjustment estimateId={this.state.estimateId} adjustment={estimateDetail['remittance_adjustments']}
                                   close={this.handleView} alertMessage={this.adjustmentUpdateInfo}/>}
            </div>
            }
        </div>);
    }
}

export default AccountRemittanceContainer(ViewRemittanceEstimate);


// WEBPACK FOOTER //
// ./src/views/accounts/remittance/view_estimate.js